import { SectionToggleState, useSectionHelper } from "hooks";
import { FormCollapse } from "components/Form";
import React from "react";
import { Section } from "containers/Settings/RuleBooks/Rules/CustomRules/constants";
import { ToFromHeader } from "./ToFromHeader";
import { ToFromForm } from "./ToFromForm";

interface ToFromSectionProps {
  sectionToggleState: SectionToggleState;
  ruleInputPath: string | null;
  parentInputPath: string | null;
  showPrerequisiteRuleSource: boolean;
}

export function ToFromSection(props: ToFromSectionProps) {
  const {
    sectionToggleState,
    parentInputPath,
    ruleInputPath,
    showPrerequisiteRuleSource,
  } = props;
  const { isOpen, onToggle } = useSectionHelper(
    sectionToggleState,
    Section.TO_FROM,
  );

  const header = <ToFromHeader />;

  return (
    <FormCollapse
      isOpen={isOpen}
      onToggle={onToggle}
      header={header}
      dataTour={isOpen ? "hideFromTo" : "showFromTo"}
    >
      <ToFromForm
        ruleInputPath={ruleInputPath}
        parentInputPath={parentInputPath}
        showPrerequisiteRuleSource={showPrerequisiteRuleSource}
      />
    </FormCollapse>
  );
}
